import React, { Component, Fragment } from 'react';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { Col, Row } from 'reactstrap';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaLogoHeader } from '../ReactIcons/ArcaLogoHeader';

export class ContactUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    resize() {
        this.setState({
            isSmartphone: ArcaHttpSystem.IsSmartphone
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    render() {

        let contactUs = <Fragment>
            <h2>Contact Us</h2>
            <a href={"phone: 07765 403 032"}>{'  '}07765 403 032</a><br />
            <a href={"mailto: admin@arcapets.co.uk"}>{'  admin@arcapets.co.uk'}</a>  <br />
        </Fragment>

        let followUs = <Fragment>
            <h2>Follow Us</h2>
            <a href='https://www.facebook.com/arcapetcare'><FaFacebook size='30px' />{'  '}</a>
            <a href='https://www.instagram.com/arcapetcare'><FaInstagram size='30px' />{'  '}</a> <br />
        </Fragment>

        let image = <Fragment>
            <ArcaLogoHeader isFooter={true} />
        </Fragment>

        let barkers = <Fragment>
            <a href='https://bristol-barkers.co.uk/'>
                <img src={require('../../../../src/images/Barkers.png')} height='65px' />
            </a>
            <p>We love Bristol Barkers and we think you will too. Here you can find some fantastic walks to enjoy with your dog.</p>
            </Fragment>


        return (
            <Fragment>
                <div id='contactUs' className='contactDetails'>

                    {this.state.isSmartphone
                        ? <Fragment>
                            <Row>
                                <Col xs='12'>
                                    {contactUs}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='12'>
                                    {followUs}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='12'>
                                    {image}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='12'>
                                    {barkers}
                                </Col>
                            </Row>
                        </Fragment>
                        : <Fragment>
                            <Row>
                                <Col xs='1'>
                                </Col>
                                <Col xs='4'>
                                    {contactUs}
                                </Col>
                                <Col xs='2'>
                                </Col>
                                <Col xs='4'>
                                    {followUs}
                                </Col>
                                <Col xs='1'>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '50px' }}>
                                <Col xs='4'>
                                </Col>
                                <Col xs='4'>
                                    {image}
                                </Col>
                                <Col xs='4'>
                                </Col>
                            </Row>
                          
                            <Row style={{ marginTop: '50px' }}>
                                <Col xs='2'>
                                </Col>
                                <Col xs='8'>
                                    {barkers}
                                </Col>
                                <Col xs='2'>
                                </Col>
                            </Row>
                        </Fragment>
                    }
                </div>

            </Fragment>
        );
    }
}